angular.module("UI8.components").component("passDetails", {
  template: `<div class="aap">
      <div class="page__sphere" id="aap-sphere"></div>
      <div class="aap__container container">
        <div class="aap__head">
          <h1 class="aap__title">{{ $ctrl.data.subtitle }}</h1>
          <p class="aap__subtitle">{{ $ctrl.data.description }}</p>
        </div>
        <pass-pricing subscriptions='::$ctrl.data.subscriptions' lifetime='::$ctrl.data.lifetime' promo='::$ctrl.data.promo'></pass-pricing>
        <div class="aap__cancel">Cancel anytime, no questions asked &mdash; your plan stays active through the end of its billing period.</div>
        ` +
    // Feature sections (Every Product / Persona / Drop / Raw / Design DNA)
    // parked 2026-07 to keep the sale page clean — uncomment to restore.
    // <div class="feat">
    //   <div class="feat__item" ng-repeat="feature in $ctrl.data.features">
    //     <div class="feat__col">
    //       <div class="feat__title">{{ feature.title }}</div>
    //       <div class="feat__text">{{ feature.description }}</div>
    //       <button
    //         class="feat__btn btn"
    //         ng-if="feature.buttonUrl === 'open:search'"
    //         ng-click="$ctrl.openSearch()"
    //       >{{ feature.buttonText }}</button>
    //       <a
    //         class="feat__btn btn"
    //         ng-if="feature.buttonUrl !== 'open:search'"
    //         ng-href="{{ feature.buttonUrl }}"
    //         ng-attr-target="{{ $ctrl.isExternalUrl(feature.buttonUrl) ? '_blank' : undefined }}"
    //       >{{ feature.buttonText }}</a>
    //     </div>
    //     <div class="feat__col">
    //       <img ng-src="{{ feature.imageUrl }}" alt="{{ feature.title }}">
    //     </div>
    //   </div>
    // </div>
    `<div class="docs">
          <div class="docs__title">Got Questions?</div>
          <ul class="docs__list">
            <li class="docs__item">
              <div class="docs__question">What is the All Access Pass?</div>
              <div class="docs__answer">The All Access Pass gives you unlimited access to UI8's entire library of 14,000+ design assets — UI kits, templates, icons, mockups, and more. It also includes Design DNA, structured design system data you can paste directly into AI coding tools to generate professional-quality UI.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Can I use these in client and commercial projects?</div>
              <div class="docs__answer">Yes — everything you download is licensed for commercial use in client work, products, and personal projects. The only things you can't do are reshare or resell the files themselves.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Will my price go up when the sale ends?</div>
              <div class="docs__answer">No. The price you subscribe at today is locked in — you'll keep renewing at the same discounted price for as long as you stay on your plan.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">What happens to my downloads if I cancel?</div>
              <div class="docs__answer">Projects you've built stay licensed. Canceling stops future billing and new downloads — it doesn't revoke your rights to work you've already created.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">What are the daily download limits for each plan?</div>
              <div class="docs__answer">Pro: 10 downloads per day. Pro+: 30 downloads per day. Lifetime: 40 downloads per day. Limits reset at midnight Pacific Time.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Do I have access to all products?</div>
              <div class="docs__answer">Pro, Pro+ and Lifetime give you access to the full UI8 library, including new releases.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Do I get access to source files?</div>
              <div class="docs__answer">Yes. You get the original source files for every product — Figma, Sketch, code, 3D assets, and more — plus Design DNA for products that support it.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Can my team share one pass?</div>
              <div class="docs__answer">Each pass is licensed to one person. If several team members need access, each needs their own plan — contact us and we'll help get your team set up.</div>
            </li>
          </ul>
          <div class="docs__hint">Couldn't find what you were looking for? <a onclick="window.$chatwoot && window.$chatwoot.toggle('open')">Contact us</a></div>
        </div>
        <div class="companies">
          <h3 class="companies__title">Chosen by creative teams globally</h3>
          <div class="companies__carousel">
            <ul class="companies__list">
              <li ng-repeat="company in $ctrl.companies">
                <img ng-src="/img/companies/{{ company }}.svg" alt="{{ company }}">
              </li>
            </ul>
            <ul class="companies__list">
              <li ng-repeat="company in $ctrl.companies">
                <img ng-src="/img/companies/{{ company }}.svg" alt="{{ company }}">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>`,

  controller: function ($location) {
    // console.log("pass-details");
    var ctrl = this;
    // console.log(ctrl.data);
    var switchers;
    var sphere;
    var sphereObserver;

    ctrl.$destroy = function () {
      if (switchers) switchers.off();
      $(".aap__question").off();
      // The sphere runs a WebGL rAF loop; leaving it alive after the route
      // changes would keep rendering an element that no longer exists.
      if (sphereObserver) sphereObserver.disconnect();
      if (sphere && sphere.pause) sphere.pause();
    };

    ctrl.isExternalUrl = function (url) {
      return url && url.indexOf("http") === 0;
    };

    ctrl.openSearch = function () {
      window.openSearch && window.openSearch();
    };

    ctrl.$onInit = function () {
      ctrl.companies = [
        "adobe",
        "airbnb",
        "amazon",
        "google",
        "microsoft",
        "netflix",
        "paypal",
        "shopify",
        "spotify",
        "stripe",
        "webflow",
      ];

      window.scrollTo(0, 0);

      // Same interactive sphere as the homepage hero, paused off-screen.
      // Angular renders this template, so the element may not exist on the
      // first frame — and hero-sphere.js is a plain bundle global that may
      // not have run yet — hence the rAF retry, matching featured-editorial.
      (function waitForHero() {
        var sphereEl = document.getElementById("aap-sphere");
        if (!sphereEl || !window.HeroSphere || !window.HeroSphere.initHero)
          return requestAnimationFrame(waitForHero);

        // 30 of the 50 cards: this is a direct-landing commercial page, so it
        // trades a little repetition on the sphere for ~20 fewer image requests.
        sphere = window.HeroSphere.initHero(sphereEl, "/img/cards/", null, 30);
        sphereObserver = new IntersectionObserver(function (entries) {
          if (!sphere || !sphere.pause) return;
          if (entries[0].isIntersecting) sphere.resume();
          else sphere.pause();
        });
        sphereObserver.observe(sphereEl);
      })();

      if (!ctrl.data.promo && window.UI8.promo) {
        ctrl.data.promo = window.UI8.promo;
      }
      if (!ctrl.data.lifetime && window.UI8.lifetime) {
        ctrl.data.lifetime = window.UI8.lifetime;
      }
      // TODO: what problem that we're doing this? (Artur)
      if (!ctrl.data.subscriptions && window.UI8.subscriptions) {
        ctrl.data.subscriptions = window.UI8.subscriptions;
      }

      if ($location.search().order) {
        $("html, body").animate(
          {
            scrollTop: $(".pricing-heading").offset().top - 180,
          },
          "fast"
        );
      }

      // faq
      const docsItem = $(".docs__item");

      docsItem
        .on("click", function () {
          const _this = $(this);
          if (_this.hasClass("active")) {
            _this.removeClass("active");
            _this.find(".docs__answer").slideUp();
          } else {
            docsItem.removeClass("active");
            docsItem.find(".docs__answer").slideUp();
            _this.addClass("active");
            _this.find(".docs__answer").slideDown();
          }
        })
        .first()
        .trigger("click");
    };
  },

  bindings: {
    data: "<",
  },
});
